import React, {useState} from 'react';
import TopTitleBlock from '../../Components/TopTitleBlock/TopTitleBlock';
import TopPageInfoBlock from '../../Components/TopPageInfoBlock/TopPageInfoBlock';
import s from './ListOfProducts.module.css';
import style from '../ListOfProducts/ListOfProductsTableGrid/ListOfProductsTableGrid.module.css';
import LightGreenButton from '../../Components/Buttons/LightGreenButton';
import VeryLightGreenButton from '../../Components/Buttons/VeryLightGreenButton';
import GreenButton from '../../Components/Buttons/GreenButton';
//import ButtonPlusElement from '../../Components/Buttons/ButtonPlusElement';
import ListOfProductsTableRowElement from './ListOfProductsTableGrid/ListOfProductsTableGrid';
import ShoppingTotal from '../../Components/ShoppingTotal/ShoppingTotal';
import GridTableHead from '../../Components/GridTableHead/GridTableHead';
import {useNavigate} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {useGetStoreProductListQuery} from '../../redux/userOrdersApi';
import Loader from '../../assets/Animations/PreLoaderComponent/Loader';
import {useStatusRestriction} from '../../hooks/useStatusRestriction';
import StatusRestrictionMessage from '../../Components/StatusRestrictionMessage/StatusRestrictionMessage';

const ListOfProducts = () => {
	const [seeAllProducts, setSeeAllProducts] = useState<boolean>(false);
	const {t} = useTranslation();
	const navigate = useNavigate();
	const restrictions = useStatusRestriction();

	const {data: productsData, isLoading} = useGetStoreProductListQuery(
		undefined,
		{skip: !restrictions.canAccessWarehouseSection},
	);

	if (!restrictions.canAccessWarehouseSection) {
		return (
			<div className="page__content">
				<StatusRestrictionMessage message={t('Сторінка недоступна')} />
			</div>
		);
	}

	const products = productsData?.products || null;
	const slicedProducts = seeAllProducts
		? products
		: products?.slice(0, 20) || null;
	const productsTotalInfo = productsData
		? {
				sum_points: productsData.sum_points || '',
				sum_money: productsData.sum_money || '',
				currency: productsData.currency || '',
			}
		: null;
	const handleSeeAllProducts = () => {
		setSeeAllProducts(!seeAllProducts);
	};
	return (
		<div className="page__content">
			<TopTitleBlock title={t('список товарів')} />
			<TopPageInfoBlock
				text={t(
					'На цій сторінці можна побачити список товарів на вашому складі, доступних до оформлення на даний момент',
				)}
				subText={''}
			/>
			<div className={s.greenButtonWrapper}>
				<div className={s.buttonContainer}>
					<VeryLightGreenButton
						text={t('створити оформлення')}
						onClick={() => navigate('/creation_of_design')}
					/>
					{/*<ButtonPlusElement />*/}
				</div>
				<div className={s.buttonContainer}>
					<LightGreenButton
						type={'button'}
						onClick={() => navigate('/create_invoice')}
						text={t('створити замовлення')}
					/>
					{/*<ButtonPlusElement />*/}
				</div>
				<div className={s.buttonContainer}>
					<GreenButton
						text={t('товарний звіт')}
						onClick={() => navigate('/product_report')}
					/>
					{/*<ButtonPlusElement />*/}
				</div>
			</div>
			{/* Обгортка для адаптивного горизонтального скролу */}
			{isLoading ? (
				<Loader />
			) : (
				<>
					<div className={s.tableWrapper}>
						<div className={style.tableGrid}>
							<GridTableHead
								columns={[
									'назва товару',
									'у наявності',
									'замовлено (ще не отримано)',
									'оформлено (чернетка)',
								]}
								gridTemplateColumns="2fr 1fr 1.5fr 1.5fr"
								customClassName={style.tableRow}
							/>
							{(seeAllProducts ? products : slicedProducts)?.map(
								(product, index) => (
									<ListOfProductsTableRowElement
										product={product}
										key={`product${index}`}
									/>
								),
							)}

							{products && products.length > 19 && (
								<div className={s.buttonWrapper}>
									<LightGreenButton
										type={'button'}
										text={`${t('дивитися')} ${!seeAllProducts ? t('більше') : t('менше')}`}
										onClick={handleSeeAllProducts}
									/>
								</div>
							)}
						</div>
					</div>
					<ShoppingTotal
						sumMoney={productsTotalInfo?.sum_money ?? ''}
						currency={productsTotalInfo?.currency ?? ''}
						sumBonuses={productsTotalInfo?.sum_points ?? ''}
					/>
				</>
			)}
		</div>
	);
};

export default ListOfProducts;
